import { useUIStore } from '@/stores/ui';
import { QuickUploadModal } from './QuickUploadModal';

/**
 * Renders the QuickUploadModal at the App level so it can be opened from
 * anywhere via the UI store (e.g. the Cmd+K command palette).
 *
 * The TopBar Upload button still owns its own local-state instance — the
 * two are independent so that closing one doesn't close the other.
 */
export function GlobalQuickUploadModal() {
  const open = useUIStore((s) => s.quickUploadOpen);
  const setOpen = useUIStore((s) => s.setQuickUploadOpen);
  return <QuickUploadModal open={open} onClose={() => setOpen(false)} />;
}
